export const shareForm =  { email: '' };

export const offerForm = {
    ...shareForm,
    name: '',
    phone: '',
    personalData: false,
}

export const applyForm ={ ...offerForm, city: '' };
